var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { accountDetails } from "@salesdi";
import { useSelector } from "react-redux";
import { upiExp } from "@frameworks/web/utils/regex";
var inputfield = {
    upi: "",
};
var UpiPopup = function (props) {
    var _a, _b;
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var _c = __read(React.useState(inputfield), 2), formData = _c[0], setFormData = _c[1];
    var _d = __read(React.useState(inputfield), 2), error = _d[0], setError = _d[1];
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var handleChange = function (event) {
        var _a;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[event.currentTarget.name] = event.currentTarget.value, _a)));
    };
    var handleUPISubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var createdBy, payload, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1:
                    createdBy = _a.sent();
                    if (!createdBy) return [3 /*break*/, 3];
                    payload = [
                        {
                            id: 0,
                            acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
                            upi: formData.upi,
                            bankAcNo: "",
                            bankName: "",
                            source: "RM",
                            createdBy: createdBy,
                            createdDate: "",
                            modifyBy: createdBy,
                            modifyDate: "",
                        },
                    ];
                    return [4 /*yield*/, di.clients.addupiDetails(payload)];
                case 2:
                    resp = _a.sent();
                    if (resp && resp.upiSuccess) {
                        props.setUpiDetailsPopup(false);
                        props.setGetDetailsUPIAPICall(true);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "UPI ID"),
        React.createElement(InputField, { className: "mgt-10 RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "Aaamoney@icici", pattern: upiExp, onBlur: function (error, event) {
                if (error.required)
                    validationError(event.target.name, "This field is Required");
                else if (!error.pattern)
                    validationError(event.target.name, "Please enter a valid UPI ID");
                else
                    validationError(event.target.name, "");
            }, onChangeEvent: function (e) { return handleChange(e); }, errorText: error.upi, defaultValue: formData.upi, id: "upi", name: "upi", maxLength: 25, required: true, autoComplete: "off" }),
        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", className: "mgt-20 w-100", onClick: function () { return handleUPISubmit(); }, disabled: ((_a = error === null || error === void 0 ? void 0 : error.upi) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = formData === null || formData === void 0 ? void 0 : formData.upi) === null || _b === void 0 ? void 0 : _b.length) <= 0 })));
};
export default UpiPopup;
